module.exports = Gateway;

function Gateway(config) {
    this.config = config
}

Gateway.prototype = {
    setCallbacks: function(onConnected, onClose, onMessage) {
        this._onConnected = onConnected
        this._onClose = onClose
        this._onMessage = onMessage
    },
    createConnection: function(){
        this._socket = new WebSocket(`ws://${this.config.serverIp}:${this.config.serverPort}${this.config.serverApiPath}`)
        var gateway = this;
        
        this._socket.onopen = function() {
            if (gateway._onConnected) gateway._onConnected();
            clearInterval(gateway._reconnectTimerId);
        }
        this._socket.onclose = function() {
            if(gateway._onClose) gateway._onClose();
            clearInterval(gateway._reconnectTimerId);
            gateway._reconnectTimerId = setInterval(function() {
                gateway.createConnection();
            }, 5000);
        }
        if (gateway._onMessage !== null) this._socket.onmessage = function(event){ gateway._onMessage(event.data) }
    },
    sendMessage: function(message) {
        this._socket.send(message);
    },
    terminateConnection: function(){
        this._socket.close()
    }
}